import React from "react";
import {
	CheckCircleIcon,
	PencilIcon,
	BuildingOfficeIcon,
	UserIcon,
	EnvelopeIcon,
	MapPinIcon,
} from "@heroicons/react/20/solid";
import Button from "../../../shared/components/FormElements/Button";

const PracticeConfirmation = ({ formikProps, selectedAddress, onEdit }) => {
	const { values } = formikProps;

	return (
		<div className="space-y-6">
			<div className="bg-slate-50 border border-slate-200 rounded-xl p-6">
				<div className="flex items-center justify-between mb-6">
					<div className="flex items-center space-x-2">
						<CheckCircleIcon className="size-5 text-green-600" />
						<h3 className="text-lg font-semibold text-slate-900">
							Gegevens bevestigd
						</h3>
					</div>
					<Button
						type="button"
						onClick={onEdit}
						ghost
						size="medium"
						iconPrefix={PencilIcon}
					>
						Bewerken
					</Button>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
					{/* Personal Information */}
					<div className="space-y-4">
						<div className="flex items-start space-x-3">
							<UserIcon className="size-4 text-slate-500 mt-1 flex-shrink-0" />
							<div className="min-w-0 flex-1">
								<div className="text-xs font-medium text-slate-500 uppercase tracking-wide">
									Contactpersoon
								</div>
								<div className="text-sm font-medium text-slate-900 mt-1">
									{values.firstName} {values.lastName}
								</div>
							</div>
						</div>

						<div className="flex items-start space-x-3">
							<EnvelopeIcon className="size-4 text-slate-500 mt-1 flex-shrink-0" />
							<div className="min-w-0 flex-1">
								<div className="text-xs font-medium text-slate-500 uppercase tracking-wide">
									E-mailadres
								</div>
								<div className="text-sm font-medium text-slate-900 mt-1">
									{values.email}
								</div>
							</div>
						</div>

						<div className="flex items-start space-x-3">
							<BuildingOfficeIcon className="size-4 text-slate-500 mt-1 flex-shrink-0" />
							<div className="min-w-0 flex-1">
								<div className="text-xs font-medium text-slate-500 uppercase tracking-wide">
									Praktijk
								</div>
								<div className="text-sm font-medium text-slate-900 mt-1">
									{values.practiceName}
								</div>
								<div className="text-xs text-slate-600 mt-1">
									{values.aantalKamers} kamer
									{values.aantalKamers > 1 ? "s" : ""}
								</div>
							</div>
						</div>
					</div>

					{/* Address Information */}
					<div className="space-y-4">
						<div className="flex items-start space-x-3">
							<MapPinIcon className="size-4 text-slate-500 mt-1 flex-shrink-0" />
							<div className="min-w-0 flex-1">
								<div className="text-xs font-medium text-slate-500 uppercase tracking-wide">
									Factuuradres
								</div>
								<div className="text-sm font-medium text-slate-900 mt-1">
									{selectedAddress.name}
								</div>
								<div className="text-sm text-slate-700 mt-1">
									{selectedAddress.address.street}
								</div>
								<div className="text-sm text-slate-700">
									{selectedAddress.address.postalCode}{" "}
									{selectedAddress.address.city}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PracticeConfirmation;
